import { useNavigate } from "react-router-dom";
import useStore from "../utils/store";

const useValidate = () => {
  const navigate = useNavigate();
  const user = useStore((state) => state.user);

  return [navigate, user];
};

export default useValidate;
